import { Box, Button, Flex, Text } from '@chakra-ui/react';
import { ChakraPageTitle, ContentContainer } from 'app/components/Core';
import { ImportCSV, ImportSongs } from 'app/components/Import';
import { useAppDispatch, useAppSelector } from 'app/store';
import { getImportStatus } from 'app/store/Import/selectors';
import { ContentContainerType } from 'types/enums';
import { openIntercomAction } from 'app/store/Mixpanel/slice';
import { useIntercom } from 'react-use-intercom';
import { SettingsBackButton } from 'app/components/Settings/SettingsBackButton';
import { ImportStatus } from './ImportStatus';

export const Import = () => {
  const dispatch = useAppDispatch();
  const status = useAppSelector(getImportStatus);
  const { show } = useIntercom();

  return (
    <ContentContainer
      type={ContentContainerType.FORM}
      display="block"
      px={2}
      pt={4}
      pb="60px"
    >
      <SettingsBackButton />
      <Flex alignItems="center" gap={0} pt={4}>
        <ChakraPageTitle flex={1}>Import</ChakraPageTitle>
      </Flex>
      <Text color="M.60" fontSize="xs" pt={1}>
        If you have any problems please&nbsp;
        <Button
          height={4}
          p={0}
          mb={1}
          variant="text"
          fontSize="xs"
          onClick={() => {
            show();
            dispatch(openIntercomAction());
          }}
        >
          contact us
        </Button>
      </Text>
      <Box my={8} position="relative">
        <Text fontWeight="500" fontSize="md" mb={2}>
          Upload song meta data
        </Text>
        <ImportCSV />
      </Box>
      <Box position="relative">
        <Box mb={2}>
          <Flex gap={2}>
            <Text fontWeight="500" fontSize="md">
              Upload song audio and lyrics
            </Text>
            <ImportStatus status={status} />
          </Flex>
          {status === 'in_progress' && (
            <Text color="red.500">
              Please keep window open until the import is finished
            </Text>
          )}
        </Box>
        <ImportSongs />
      </Box>
    </ContentContainer>
  );
};
